import React from 'react';
import ServiceComponent from './ServiceComponent';
import {Helmet} from 'react-helmet'
export default function BTLComponent() {

    const description = `Diseñamos y ejecutamos experiencias creativas, memorables y de alto impacto a través de la definición de estrategias que logren llegar de forma asombrosa a
    los diferentes targets de comunicación.`

  return (
    <>
    <Helmet>
      <title>Servicios BTL | Blue Group Marketing | Bolivia</title>
      <meta
        name="description"
        content="Diseñamos y ejecutamos experiencias BTL creativas, memorables y de alto impacto con activaciones de marca, endomarketing y eventos corporativos en Bolivia."
      />
      <meta name="keywords" content="btl, activaciones de marca, endomarketing, eventos corporativos, publicidad btl, cochabamba, bolivia" />
      <meta name="robots" content="index, follow"/>
      <meta name="googlebot" content="index, follow"/>
      <link rel="canonical" href={`${process.env.FRONTENDURL}BTLservices`} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="article" />
      <meta property="og:site_name" content="Blue Group Marketing" />
      <meta property="og:url" content={`${process.env.FRONTENDURL}BTLservices`} />
      <meta property="og:title" content="Servicios BTL | Blue Group Marketing | Bolivia" />
      <meta property="og:description" content="Diseñamos y ejecutamos experiencias BTL creativas, memorables y de alto impacto con activaciones de marca, endomarketing y eventos corporativos en Bolivia." />
      <meta property="og:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />

      {/* Twitter Cards */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content="Servicios BTL | Blue Group Marketing | Bolivia" />
      <meta name="twitter:description" content="Diseñamos y ejecutamos experiencias BTL creativas, memorables y de alto impacto con activaciones de marca, endomarketing y eventos corporativos en Bolivia." />
      <meta name="twitter:image" content="https://bluegroupmarketing.com/bluegroupog.jpg" />
    </Helmet>
    <ServiceComponent description={description} service="BTL" type="BTL" fontsize="9">
      <div className="max-w-7xl mx-auto">
        <ul className="text-3xl italic font-bold mt-20 text-center sm:text-left">
          <li className="text-bluegroup-100 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Endomarketing" src={require('../../assests/OurServices/BTL/endomarketing_icon.png')}/>Endomarketing</li>
          <li className="text-bluegroup-800 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Activaciones de marca" src={require('../../assests/OurServices/BTL/activaciones_icon.png')}/>Activaciones</li>
          <li className="text-bluegroup-300 mb-10"><img className="sm:inline w-20 mx-auto sm:mx-5" alt="Icono de Eventos BTL" src={require('../../assests/OurServices/BTL/eventos_icon.png')}/>Eventos</li>
        </ul>
      </div>
    </ServiceComponent>
    </>
  );
}
